import * as React from 'react'
import styled from 'styled-components'
import * as reactColorful from 'react-colorful'

import { useLoseFocus } from '../../../hooks'
import * as S from '../../../styles'

import * as behaviours from '../../../behaviours'

export type ColorInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> & {
  onChange: (color: string) => void
  size?: number
  value: string
  status: behaviours.FieldStatus
}
function ColorInputComponent({
  className,
  size,
  status,
  onChange,
  ...inputProps
}: ColorInputProps): React.ReactElement {
  const [colorPickerIsOpen, setColorPickerIsOpen] = React.useState(false)
  const $refColorPicker = React.useRef<HTMLDivElement>(null)
  const $refInput = React.useRef<HTMLInputElement>(null)

  useLoseFocus($refColorPicker, () => {
    colorPickerIsOpen && setColorPickerIsOpen(false)
  }, [colorPickerIsOpen])

  return (
    <S.colorPicker.Container
      className={className}
      ref={$refColorPicker}
      onClick={() => {
        $refInput.current?.focus()
        setColorPickerIsOpen(true)
      }}
    >
      <S.colorPicker.ColorDisplay $size={size} $color={String(inputProps.value)} />
      <S.colorPicker.InputWrapper>
        <S.input.Prefix>#</S.input.Prefix>
        <S.input.Input
          $status={status}
          onChange={(event) => {
            onChange(!event.target.value.startsWith('#') ? `#${event.target.value}` : event.target.value)
          }}
          ref={$refInput}
          {...inputProps}
          value={inputProps.value.replace('#', '')}
        />
      </S.colorPicker.InputWrapper>
      {colorPickerIsOpen && (
        <reactColorful.HexColorPicker
          color={String(inputProps.value)}
          onChange={(color) => {
            onChange(color)
          }}
        />
      )}
    </S.colorPicker.Container>
  )
}

export const ColorInput = styled(ColorInputComponent)<ColorInputProps>`
  position: relative;

  ${S.input.Prefix} {
    width: 42px;
  }

  .react-colorful {
    position: absolute;
    bottom: 60px;
    left: 11px;
  }
`
ColorInput.displayName = 'ColorInput'
